/**
 * Member label for dropdowns/lists: "Name(250)" or mixed "Name(Shop 250)"
 */
export function formatMemberDisplayName(member, societyUnitType = null) {
  const name = member.name || member.member_name || "";
  const house = member.house_number || member.member_house_number || "";
  if (!house) return name;

  let prefix = "";
  const ut = societyUnitType;
  if (ut == 3 || ut === "3") {
    if (member.unit_type == 2 || member.unit_type === "2") prefix = "Shop ";
    else if (member.unit_type == 1 || member.unit_type === "1") prefix = "House ";
  }

  return `${name}(${prefix}${house})`;
}

export function mapMemberWithDisplayName(member, societyUnitType = null) {
  return {
    ...member,
    display_name: formatMemberDisplayName(member, societyUnitType),
  };
}

export function mapMembersWithDisplayName(members, societyUnitType = null) {
  return (members || []).map((m) => mapMemberWithDisplayName(m, societyUnitType));
}
